<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Ordenes con facturas pendientes</h4>
        <button type="button" class="close" (click)="exit()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form>
        <div class="modal-body">
            <h6>Es necesario completar todas las facturas o recibos de estas ordenes, para poder realizar el cierre de caja</h6>
            <pos-table #invoiceWithoutPaymentTable tableFormId="orderWithPendingInvoiceTable" [headers]="getTableColumns()"
            [data]="ordersWithPendingInvoice"
            [itemsPerPage]="10" (dataChange)="getData($event)" (rowClick)="goToOrder($event)">
          </pos-table>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-success" (click)="exit()">Cerrar</button>
        </div>
    </form>
</div><!-- /.modal-content -->